export default class SearchEngineAdapter {
    constructor(data = []) {
        this.data = data.data;
        this.aggegation = data.aggregations?.count_by_type;
        this.result = {};
    }

    build() {
        this.result = this.getStructure();
        return this.feed(this.extractDataByType());
    }

    extractDataByType() {
        let data = [];

        if (this.data) {
            data = this.data.filter((item) => {
                return item.object.type == this.key && !item.is_archived;
            });
        }
        return data;
    }

    feed(data) {
        if (data.length > 0) {
            this.result.items = data.map((item) => this.formatItem(item));
        }
        this.result.count = this.aggegation[this.key]
            ? this.aggegation[this.key][0]
            : this.result.items.length;
        return this.result;
    }

    formatAddress(address) {
        if (address) {
            let addressFromatted = address.id ? address.postal_code + ' ' + address.city : '';
            if (addressFromatted != '' && address.country_code != 'FR') {
                addressFromatted += ' ' + address.country_code;
            }
            return addressFromatted;
        }
        return false;
    }
}
